document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('[data-sst-rates-grid]');
  var toggle = document.querySelector('[data-sst-rates-toggle]');
  if (!grid || !toggle) return;

  var label = toggle.querySelector('[data-sst-rates-toggle-label]');
  var moreText = label.textContent;
  var lessText = toggle.getAttribute('data-collapse-label') || 'Show Less';

  toggle.addEventListener('click', function () {
    var expanded = grid.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    label.textContent = expanded ? lessText : moreText;
  });
});
